import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { SheinShopProvider } from '@/shein-platform/context/SheinShopContext';
import SheinShopTopBar from '@/shein-platform/layout/SheinShopTopBar';
import SheinNoticeDrawerHost from '@/shein-platform/components/SheinNoticeDrawerHost';
import { SHEIN_SHOP_SWITCH_TOAST_KEY } from '@/shein-platform/constants/sheinRoutes';
import { showToast } from '@/utils/toast';
import '@/styles/shein-platform/shein-platform.css';
import '@/styles/shein-platform/shein-product-ops.css';

/**
 * 发布 / 编辑产品专用布局：保留顶栏店铺上下文，无左侧菜单。
 */
export default function SheinProductEditorLayout() {
  useEffect(() => {
    try {
      const raw = sessionStorage.getItem(SHEIN_SHOP_SWITCH_TOAST_KEY);
      if (!raw) return;
      sessionStorage.removeItem(SHEIN_SHOP_SWITCH_TOAST_KEY);
      const payload = JSON.parse(raw);
      if (payload?.message) {
        showToast(payload.message, payload.type || 'success');
      }
    } catch {
      sessionStorage.removeItem(SHEIN_SHOP_SWITCH_TOAST_KEY);
    }
  }, []);

  return (
    <SheinShopProvider>
      <div
        className="shein-platform shein-platform--editor"
        data-testid="shein-product-editor-layout"
      >
        <SheinShopTopBar />
        <SheinNoticeDrawerHost />
        <div className="shein-platform__body shein-platform__body--editor">
          <main className="shein-platform__main shein-platform__main--product-ops shein-platform__main--editor">
            <Outlet />
          </main>
        </div>
      </div>
    </SheinShopProvider>
  );
}
